import color from 'css-color-function'
import rgbHex from 'rgb-hex'
import formula from '@/constant/formula.json'
import axios from 'axios'

// 直接注入新的element的css
export const writeNewStyle = elNewStyle => {
  const style = document.createElement('style')
  style.innerHTML = elNewStyle
  document.head.appendChild(style)
}

// 用生成的色表中的颜色替换element默认css中的变量
export const generateNewStyle = async primaryColor => {
  const colors = generateColors(primaryColor)
  let cssText = await getOriginalStyle()
  Object.keys(colors).forEach(key => {
    cssText = cssText.replace(
      new RegExp(`(:|\\s+)${key}`, 'g'),
      '$1' + colors[key]
    )
  })
  return cssText
}

// 利用色表公式和rgbHex函数，生成色表
export const generateColors = primary => {
  if (!primary) return
  const colors = {
    primary
  }
  Object.keys(formula).forEach(key => {
    const value = formula[key].replace(/primary/g, primary)
    colors[key] = '#' + rgbHex(color.convert(value))
  })
  return colors
}

// 获取element的默认css
const getOriginalStyle = async () => {
  const version = require('element-plus/package.json').version
  const url = `https://unpkg.com/element-plus@${version}/dist/index.css`
  const { data } = await axios.get(url)
  return getStyleTemplate(data) // 将element的默认色表中的颜色改为下面的shade-1等变量
}

// 将element的默认css中的颜色改为shade-1等变量
const getStyleTemplate = data => {
  const colorMap = {
    '#3a8ee6': 'shade-1',
    '#409eff': 'primary',
    '#53a8ff': 'light-1',
    '#6bbfff': 'light-2',
    '#79bbff': 'light-3',
    '#8cc5ff': 'light-4',
    '#a0cfff': 'light-5',
    '#b3d8ff': 'light-6',
    '#c6e2ff': 'light-7',
    '#d9ecff': 'light-8',
    '#ecf5ff': 'light-9'
  }
  Object.keys(colorMap).forEach(key => { // 用这个对象去检索data，将data中所有的key替换为value
    const value = colorMap[key]
    data = data.replace(new RegExp(key, 'ig'), value)
  })
  return data
}
